import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Theme, ThemeType} from 'app/core/interfaces/common.interface';
import {FormService} from 'app/core/services/form.service';
import {ThemeCustomizationService} from 'app/core/services/theme-customization.service';
import {DropDownDirective} from 'app/shared/directives/drop-down.directive';
import {AuthService} from 'app/core/services/auth.service';
import {Subscription} from 'rxjs';

@Component({
    selector: 'settings-page',
    templateUrl: './settings-page.component.html',
    styleUrls: ['../default-main-page/default-main-page.component.scss', './settings-page.component.scss'],
    providers: [FormService],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsPageComponent implements OnInit, OnDestroy {
    @ViewChild(DropDownDirective) dropdown: DropDownDirective;

    form: FormGroup;
    themeState: Theme | null;
    ThemeType = ThemeType;
    sub = Subscription.EMPTY;

    constructor(
        public formService: FormService,
        private fb: FormBuilder,
        private authService: AuthService,
        public themeCustom: ThemeCustomizationService,
        private cd: ChangeDetectorRef
    ) {}

    ngOnInit() {
        this.sub = this.authService.currentUser$.subscribe(user => {
            if (user === null) {
                return;
            }

            this.themeState = this.themeCustom.themeBaseSettings;
            this.initSettingsForm();
            this.cd.markForCheck();
        });
    }

    initSettingsForm() {
        this.form = this.fb.group({
            MonetizationTheme: [this.themeState.selectedTheme.theme, Validators.required],
            chartTopLimit: [this.themeState.chartsDefaults.topLimit],
            hideEmptySeries: [this.themeState.chartsDefaults.hideEmptySeries],
            showMissingPoints: [this.themeState.chartsDefaults.showMissingPoints],
        });
        this.formService.init(this.form);
    }

    saveSelectedPageView(value: {
        chartTopLimit: number;
        hideEmptySeries: boolean;
        MonetizationTheme: ThemeType;
        showMissingPoints: boolean;
    }): void {
        this.formService
            .submit(
                this.themeCustom.setDashboardSettings({
                    selectedTheme: {
                        theme: value.MonetizationTheme,
                        popupShown: true,
                    },
                    chartsDefaults: {
                        topLimit: Number(value.chartTopLimit),
                        hideEmptySeries: value.hideEmptySeries,
                        showMissingPoints: value.showMissingPoints,
                    },
                })
            )
            .subscribe(
                settings => {
                    console.debug('view page is selected!', settings);
                    this.themeState = settings.dashboardSettings;
                },
                err => {
                    console.error(err, 'failed setup settings page!');
                    this.formService.catchError(err);
                }
            );
    }

    onSubmit() {
        this.saveSelectedPageView(this.form.value);
        this.dropdown.toggleContent(false);
    }

    hideSettingsDropdown() {
        this.dropdown.toggleContent(false);
        this.initSettingsForm();
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }
}
